import { Checkbox } from "@vds/checkboxes";
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Modal, Select } from "antd";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { fetchUserEndPoint } from "../../../configuration";
import CircleIIcon from "../../../assets/circle_i.svg";
import ATSToolTip from "../../../global/components/ATSToolTip";
import TooltipContent from "./TooltipContent";
import {
  createUserList,
  updateUserList,
  fetchOrganization,
  fetchRoles,
} from "../../../global/utility/Utils";
import { DeleteUserModal } from "../UserModal";
import { getRandomUUID } from "../../../Token";
import { deleteUserEndPoint } from "../../../configuration";
import ValidationIcon, {
  getInputClassNamesUser,
  ErrorMessage,
} from "../../../global/components/ValidationIcon";
import { MAX_CHAR_LIMITS, getCharLimitMsgIfExceeded } from "../../../global/constants/inputLimits";
import ToastNotification from "../../../global/components/ToastNotification";
const optionStyles = {
  padding: "10px",
  width: "100%",
  borderBottom: "1px solid #D8DADA",
};
const dropdownStyles = {
  border: "1px solid #D8DADA",
  borderRadius: "10px",
  padding: "5px",
};

const CreateUserModel = ({
  visible,
  rolesListData,
  onClose,
  onSave,
  state,
  role_id,
  org_id,
  onUserCreated,
}) => {
  let navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  // let smsChecked = false;
  let smsChecked = true;
  const nameRegex = /^[A-Za-z0-9 _]+$/;

  const [showDeleteUser, setShowDeleteUser] = useState(false);
  const [deleteUserConfirmed, setDeleteUserConfirmed] = useState(false);
  const [organizationList, setOrganizationList] = useState([]);
  const [rolesList, setRolesList] = useState(rolesListData || []);
  const [notificationProps, setNotificationProps] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [sendSMS, setSendSMS] = useState(smsChecked);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "+1",
    organization: org_id !== undefined ? org_id : "",
    role: role_id !== undefined ? role_id : "",
    oldroleid: "",
  });

  const [errors, setErrors] = useState({
    firstName: "initial",
    lastName: "initial",
    email: "initial",
    mobileNumber: "initial",
    organization: "",
    role: "initial",
  });

  const [dataList, setDataList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const fetchUser = async (value) => {
    try {
      let activeSession = sessionStorage.getItem("activeSession");
      if (activeSession) {
        activeSession = JSON.parse(activeSession);
      }
      const response = await fetch(fetchUserEndPoint(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
          "VZ-M2M-Token": getRandomUUID(),
        },
        method: "POST",
        body: JSON.stringify({
          accountName: sessionStorage.getItem("accountId"),
          // currentrole: activeSession?.role?.name,
          currentrole: "ORG_ADMIN",
          filter: {
            $selection: `(email eq '${value}')`,
            $sort: [
              {
                field: "createdon",
                order: "desc",
              },
            ],
            $limitnumber: 500,
            $pagenumber: 0,
            $querytotalcount: true,
          },
        }),
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      return error;
    }
  };

  const formatPhoneNumber = (value) => {
    // Handle null/undefined values
    if (!value) return "+1";

    const digits = value.replace(/\D/g, "").replace(/^1/, "").slice(0, 10);
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 10);
    if (digits.length >= 7) {
      return `+1 ${part1}-${part2}-${part3}`;
    } else if (digits.length >= 4) {
      return `+1 ${part1}-${part2}`;
    } else if (digits.length > 0) {
      return `+1 ${part1}`;
    } else {
      return `+1`;
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target ? e.target : e;
    setFormData({ ...formData, [name]: value });

    let tempErrors = { ...errors };
    switch (name) {
      case "firstName":
        tempErrors.firstName =
          value && value.trim() !== ""
            ? nameRegex.test(value.trim())
              ? ""
              : "Special characters are not allowed."
            : "Please enter a first name";
        break;
      case "lastName":
        tempErrors.lastName =
          value && value.trim() !== ""
            ? nameRegex.test(value.trim())
              ? ""
              : "Special characters are not allowed."
            : "Please enter a last name";
        break;
      case "email":
        if (state?.id === undefined) {
          if (!/\S+@\S+\.\S+/.test(value)) {
            tempErrors.email = "Please enter a valid email address";
          } else {
            try {
              tempErrors.email = "";
              // const response = await fetchUser(value);
              // if (response?.length > 0) {
              //   tempErrors.email = "Email address already exists";
              // } else {
              //   tempErrors.email = "";
              // }
            } catch (error) {
              tempErrors.email = "Error checking email";
            }
          }
        }
        else {
          tempErrors.email = "";
        }
        break;
      case "mobileNumber":
        const digitsOnly = value.replace(/\D/g, '').replace(/^1/, '').slice(0, 10);
        if (digitsOnly.length === 10) {
          tempErrors.mobileNumber = ""; // Valid
        } else if (value.length > 0 && digitsOnly.length < 10) {
          tempErrors.mobileNumber = "Enter 10-digit number";
        } else {
          tempErrors.mobileNumber = "Phone number is required";
        }
        break;
      case "role":
        tempErrors.role = value ? "" : "Please select a role";
        break;
      default:
        break;
    }
    setErrors(tempErrors);
  };
  const handleBlur = async (e) => {
    const { name, value } = e.target;
    if (name !== "email" || state?.id) return;

    if (/\S+@\S+\.\S+/.test(value)) {
      try {
        const response = await fetchUser(value);
        setErrors(prev => ({
          ...prev,
          email: response?.length > 0 ? "Email already exists" : ""
        }));
      } catch {
        setErrors(prev => ({ ...prev, email: "Error checking email" }));
      }
    }
  };
  const handleSubmit = async () => {
    let tempErrors = { ...errors };
    tempErrors.firstName =
      formData.firstName && formData.firstName.trim() !== ""
        ? nameRegex.test(formData.firstName.trim())
          ? ""
          : "Special characters are not allowed."
        : "Please enter a first name";

    tempErrors.lastName =
      formData.lastName && formData.lastName.trim() !== ""
        ? nameRegex.test(formData.lastName.trim())
          ? ""
          : "Special characters are not allowed."
        : "Please enter a last name";
    if (state?.id === undefined) {
      if (!/\S+@\S+\.\S+/.test(formData.email)) {
        tempErrors.email = "Please enter a valid email address";
      } else {
        try {
          const response = await fetchUser(formData.email);
          if (response?.length > 0) {
            tempErrors.email = "Email address already exists";
          } else {
            tempErrors.email = "";
          }
        } catch (error) {
          tempErrors.email = "Error checking email";
        }
      }
    } else {
      tempErrors.email = "";
    }
    const digitsOnlyForSubmission = formData.mobileNumber.replace(/\D/g, '').replace(/^1/, '').slice(0, 10);
    if (digitsOnlyForSubmission.length !== 10) {
      tempErrors.mobileNumber = "Enter 10-digit number";
    } else {
      tempErrors.mobileNumber = "";
    }
    tempErrors.role = formData.role ? "" : "Please select a role";
    setErrors(tempErrors);
    if (Object.values(tempErrors).some((x) => x !== "")) {
      setNotificationProps({
        type: "error",
        message:
          state !== null && state?.createuser == undefined
            ? "Edit user"
            : "Add user",
        description: "invalid-form-data",
        duration: 1,
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    } else {
      const mobileNumberForSubmission = '1' + digitsOnlyForSubmission;
      if (selectedItem && state?.createuser == undefined) {
        const response = await updateUserList({
          ...formData,
          mobileNumber: mobileNumberForSubmission,
        });
        if (response?.status === 200 || response?.status === 204) {
          setNotificationProps({
            type: "success",
            message:
              state !== null && state?.createuser == undefined
                ? "Edit user"
                : "Add user",
            description: `User "${response.data.email}" updated successfully`,
            duration: 1,
          });
          setShowNotification(true);
          setTimeout(() => {
            onUserCreated();
            setShowNotification(false);
          }, 1000);
        } else {
          setNotificationProps({
            type: "error",
            message:
              state !== null && state?.createuser == undefined
                ? "Edit user"
                : "Add user",
            description: response.error_description || response.message,
            duration: 1,
          });
          setShowNotification(true);
          setTimeout(() => {
            setShowNotification(false);
          }, 1000);
        }
        setSelectedItem(null);
      } else {
        const newItem = { id: Date.now(), ...formData };
        const response = await createUserList(
          { ...newItem, mobileNumber: mobileNumberForSubmission },
          sendSMS
        );
        setDataList([...dataList, newItem]);
        if (response?.status === 200 || response?.status === 204) {
          // setFormData({
          //   firstName: "",
          //   lastName: "",
          //   email: "",
          //   mobileNumber: "+1",
          //   organization: "",
          //   role: "",
          // });
          setNotificationProps({
            type: "success",
            message: "Add user",
            description: `User "${response.data.email}" created successfully`,
            duration: 1,
          });
          setShowNotification(true);
          setTimeout(() => {
            onUserCreated();
            setShowNotification(false);
          }, 1000);
        } else {
          setNotificationProps({
            type: "error",
            message: "Add user",
            description: response.error_description || response.message,
            duration: 1,
          });
          setShowNotification(true);
          setTimeout(() => {
            setShowNotification(false);
          }, 1000);
        }
      }
    }
  };
  const hasAnyError = Object.values(errors).some(
    (val) => val !== "" && val !== "initial"
  );
  const deleteUser = () => {
    setShowDeleteUser(true);
  };
  const cancleModel = () => {
    onClose();
  };
  useEffect(() => { }, [showNotification, notificationProps]);
  const onConfirm = async () => {
    setDeleteUserConfirmed(true);
    setShowDeleteUser(false);

    const response = await fetch(deleteUserEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        id: state?.id,
      }),
    });
    const deleteRuleRsp = await response;
    if (deleteRuleRsp) {
      if (deleteRuleRsp?.status === 200 || deleteRuleRsp?.status === 204) {
        setNotificationProps({
          type: "success",
          message: "Delete user",
          description: `User deleted successfully`,
          duration: 1,
          style: { backgroundColor: "#d4edda", color: "#155724" },
        });
        setShowNotification(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobileNumber: "",
          organization: "",
          role: "",
        });
        setTimeout(() => {
          navigate("/users");
        }, 1000);
      } else {
        setNotificationProps({
          type: "error",
          message: "Delete user",
          description: "failed",
          duration: 1,
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
      }
    }
  };
  useEffect(() => {
    // const getData = async () => {
    //   try {
    //     const data = await fetchOrganization();

    //     if (data.length > 0) {
    //       setOrganizationList(
    //         data.filter(
    //           (d) =>
    //             d?.tags &&
    //             d?.tags.length > 0 &&
    //             d?.tags[0]?.kind === "ts.tag.org"
    //         )
    //       );
    //     }
    //   } catch (error) {}
    // };
    const getRole = async () => {
      try {
        const data = await fetchRoles();
        let roles = [];
        if (user?.role?.name !== "SUPER_ADMIN") {
          roles = data?.filter((d) => d.name !== "SUPER_ADMIN");
        } else {
          roles = data;
        }
        setRolesList(roles);
      } catch (error) {
        console.log(error);
      }
    };
    // getData();
    if (state == null && state?.createuser == undefined) {
      getRole();
    }
  }, []);

  useEffect(() => {
    if (state) {
      if (user?.role?.permissions?.users?.edit) {
        if (state.hasOwnProperty("org_id")) {
          setSelectedItem({
            organization: state?.org_id,
          });
          setFormData({
            organization: state?.org_id,
          });
        } else {
          setSelectedItem({
            firstName: state?.firstname,
            lastName: state?.lastname,
            email: state?.email,
            mobileNumber: state?.mdn,
            role: state?.customdata?.roleId,
            organization: state?.customdata?.orgId,
            oldroleid: state?.customdata?.roleId,
          });
          setFormData({
            firstName: state?.firstname,
            lastName: state?.lastname,
            email: state?.email,
            mobileNumber: state?.mdn,
            role: state?.customdata?.roleId,
            organization: state?.customdata?.orgId,
            oldroleid: state?.customdata?.roleId,
            id: state?.id,
          });
        }
      } else if (!user?.role?.permissions?.users?.create) {
        navigate("/users");
      }
    } else if (!user?.role?.permissions?.users?.create) {
      navigate("/users");
    }
  }, [state, user, navigate]);
  const handleClose = () => {
    setShowNotification(false);
  };

  const onExit = () => {
    setDeleteUserConfirmed(false);
    setShowDeleteUser(false);
    navigate(-1);
  };

  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={680} modalRender={(modal) => (
      <div style={{ height: hasAnyError ? "578px" : "550px", overflowY: "auto", borderRadius: 8 }}>
        {modal}
      </div>
    )}
    >
      <>
        {showNotification && (
          <ToastNotification
            type={notificationProps.type}
            message={notificationProps.message}
            description={notificationProps.description}
            duration={notificationProps.duration}
            style={notificationProps.style}
          />
        )}
        <div style={{ marginBottom: "10px", padding: "3px" }}>
          <h2 style={{ fontWeight: "700", fontSize: "32px", fontFamily: "VerizonNHGDSBold", color: "#000000" }}>
            {state !== null && state?.createuser == undefined
              ? "Edit user"
              : "Add user"}
          </h2>
          <br />
          <h4 className={"font-face-vzb page-sub-heading-user"}>
            Contact information
          </h4>
        </div>
        <>
          <Grid2
            container
            marginTop={"-3%"}
            // marginBottom={2}
            spacing={1}
            padding={"3px"}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6} marginBottom={0}>
              <div className="mb-3 remove-mb">
                <label htmlFor="firstName" className="input-label-user">
                  First name
                </label>
                <div className="input-container">
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={(e) => {
                      // Allow only letters and spaces
                      const regex = /^[A-Za-z0-9\s]*$/;
                      const rawValue = e.target.value;

                      if (regex.test(rawValue)) {
                        handleChange(e);
                      }
                      // else ignore input (blocks special chars)
                    }}
                    maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                    className={getInputClassNamesUser("firstName", formData, errors)}
                    style={{ boxShadow: "none" }}
                  />

                  <ValidationIcon
                    fieldName="firstName"
                    formData={formData}
                    errors={errors}
                    color={"blue"}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="firstName" errors={errors} />
                  {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData.firstName)}
                </div>
              </div>
            </Grid2>

            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3 remove-mb">
                <label htmlFor="lastName" className="input-label-user">
                  Last name
                </label>
                <div className="input-container">
                  <input
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                    onChange={(e) => {
                      // Allow only letters and spaces
                      const regex = /^[A-Za-z0-9\s]*$/;
                      const rawValue = e.target.value;

                      if (regex.test(rawValue)) {
                        handleChange(e);
                      }
                      // else ignore input (blocks special chars)
                    }}
                    className={getInputClassNamesUser("lastName", formData, errors)}
                    style={{ boxShadow: "none" }}
                  />

                  <ValidationIcon
                    fieldName="lastName"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="lastName" errors={errors} />
                  {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData.lastName)}
                </div>
              </div>
            </Grid2>

            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3 remove-mb">
                <label htmlFor="email" className="input-label-user">
                  Email
                  {/* <ATSToolTip placement="topLeft" text={<TooltipContent />}>
                  <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
                </ATSToolTip> */}
                </label>
                <div className="input-container">
                  <input
                    id="email"
                    name="email"
                    disabled={!!selectedItem && state?.createuser === undefined}
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXTAREA}
                    className={getInputClassNamesUser(
                      "email",
                      formData,
                      errors
                    )}
                    style={{ boxShadow: "none" }}
                  />
                  <ValidationIcon
                    fieldName="email"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="email" errors={errors} />
                  {getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData.email)}
                </div>
              </div>
            </Grid2>

            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3 remove-mb">
                <label htmlFor="mobileNumber" className="input-label-user">
                  Phone number
                </label>
                <div className="input-container">
                  <input
                    id="mobileNumber"
                    name="mobileNumber"
                    value={formatPhoneNumber(formData.mobileNumber)}
                    maxLength={17}
                    onChange={(e) => {
                      const rawInput = e.target.value;
                      const digits = rawInput.replace(/\D/g, "").replace(/^1/, "").slice(0, 10);
                      const formattedValue = `+1${digits}`;
                      handleChange({
                        target: { name: "mobileNumber", value: formattedValue },
                      });
                    }}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    className={getInputClassNamesUser(
                      "mobileNumber",
                      formData,
                      errors
                    )}
                    style={{ boxShadow: "none" }}
                  />
                  <ValidationIcon
                    fieldName="mobileNumber"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="mobileNumber" errors={errors} />
                </div>
              </div>
            </Grid2>
            {false && (
              <>
                <h4 className={"font-face-vzb page-sub-heading-user"}>
                  Associations
                </h4>
                <Grid2 item xs={12}>
                  <div className="mb-3">
                    <label htmlFor="organization" className="input-label-user">
                      Organization
                    </label>
                    <div className="input-container">
                      <Select
                        id="organization"
                        style={{ width: "100%", height: "50px" }}
                        name="organization"
                        value={formData.organization}
                        dropdownStyle={dropdownStyles}
                        onChange={(value) =>
                          handleChange({ name: "organization", value: value })
                        }
                        // className={getInputClassNamesUser("organization", formData, errors)}
                        aria-label=".form-select-lg example"
                      >
                        <option style={optionStyles} value="">
                          All Organizations
                        </option>
                        {organizationList.map((option) => (
                          <option
                            key={option.id}
                            value={option.id}
                            style={optionStyles} // Apply inline style to each option
                          >
                            {option.tags[0].org_name}
                          </option>
                        ))}
                      </Select>
                      <ValidationIcon
                        fieldName="organization"
                        formData={formData}
                        errors={errors}
                      />
                    </div>
                    <div style={{ paddingTop: 5 }}>
                      <ErrorMessage fieldName="organization" errors={errors} />
                    </div>
                  </div>
                </Grid2>
              </>
            )}
            <Grid2 item xs={12} style={{ marginTop: "3%" }}>
              <h4 className={"font-face-vzb page-sub-heading-user"}>
                Permissions
              </h4>
              <div className="mb-3">
                <label htmlFor="role" className="input-label-user">
                  Role
                </label>
                <div className="input-container">
                  <Select
                    id="role"
                    style={{ width: "100%", height: "50px" }}
                    name="role"
                    value={rolesList.find(role => role.id === formData.role)?.name || ''}
                    dropdownStyle={dropdownStyles}
                    onChange={(value) =>
                      handleChange({ name: "role", value: rolesList.find(role => role.name === value)?.id || '' })
                    }
                    aria-label=".form-select-lg example"
                  >
                    <option style={optionStyles} value="">
                      None
                    </option>
                    {rolesList?.map((option) => (
                      <option
                        style={optionStyles}
                        key={option?.id}
                        value={option?.name}
                      >
                        {option?.name?.toLowerCase()}
                      </option>
                    ))}
                  </Select>
                  <ValidationIcon
                    fieldName="role"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <div style={{ paddingTop: 5 }}>
                  <ErrorMessage fieldName="role" errors={errors} />
                </div>
                {/* <p class="light-grey-text-color">
                  The selected role applies to all organizations and locations
                  selected
                </p>{" "} */}
              </div>
            </Grid2>
            {/* <Grid2 item xs={12}>
              <div className="mb-3">
                <label htmlFor="twofactor" className="input-label-user">
                  Require two factor authentication
                </label>
                <div className="input-container">
                  <select
                    id="twofactor"
                    style={{ appearance: "auto", boxShadow: "none" }}
                    disabled
                    name="twofactor"
                    value={formData.twofactor}
                    onChange={handleChange}
                    className="form-control login-form-control"
                    aria-label=".form-select-lg example"
                  >
                    <option value="1">NO</option>
                    <option value="2">YES</option>
                  </select>
                  {errors.twofactor && <p className="custom-error-message">{errors.twofactor}</p>}
                </div>
                {errors.twofactor && <i className="bi bi-exclamation-diamond input-icon-failure"></i>}
                <p class="light-grey-text-color">
                  Forces user to enter code sent via email/SMS to login. Does not apply to SSO users.
                </p>
              </div>
            </Grid2> */}
          </Grid2>

          {/* {state === null || state?.createuser === true ? (
            <Checkbox
              selected={sendSMS}
              onChange={(e) => {
                setSendSMS(!sendSMS);
              }}
            >
              Send Welcome email to the new user?
            </Checkbox>
          ) : (
            ""
          )} */}
          <Grid2
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  onClick={cancleModel}
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Cancel
                </Button>
              </div>
            </Grid2>

            <Grid2 item xs={12} sm={6} md={6} lg={6} padding={"3px"} >
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  onClick={handleSubmit}
                  shape="round"
                  style={{
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                  }}
                  size={"large"}
                >
                  {state !== null && state?.createuser == undefined
                    ? "Save"
                    : "Add"}
                </Button>
              </div>
            </Grid2>
          </Grid2>
          <br />
          <DeleteUserModal
            showDeleteUser={showDeleteUser}
            setShowDeleteUser={setShowDeleteUser}
            message="Are you sure want to delete the user?"
            title="Delete User"
            onConfirm={onConfirm}
            onExit={onExit}
          />
        </>
      </>
    </Modal>
  );
};

export default CreateUserModel;
